module.exports = __webpack_public_path__ + "img/表1-3字体示例.07979703.png";